export const MANDATORY_CLIENT = 'No orama instance or cloud config was passed'
export const INVALID_INSTANCE = 'Invalid orama instance'
export const SEARCH_WENT_WRONG = "There was a problem searching your index, make sure it's set up properly."
export const ORAMA_CLIENT_NOT_INITIALIZED_YET =
  'Cannot initialize the Orama Answer Session. Orama Client is not initialized yet.'
export const LOCAL_ORAMA_DOES_NOT_SUPPORT_ANSWER_SESSION =
  'Local Orama does not support Answer Session. Please use Orama Cloud.'
